import request from './request'

export interface CareTemplateItem {
  id: number
  item_id: string
  item_name: string
  item_name_zh: string
  type: string
  type_text: string
  section: string
  duration_minutes: number
  duration_text: string
  status: number
}

export interface CareTemplate {
  id: number
  plan_key: string
  plan_text: string
  template_key: string
  template_name: string
  period_type: string
  month: number
  start_month: number | null
  end_month: number | null
  estimated_minutes: number
  estimated_hours: number
  items: CareTemplateItem[]
  baseline_items: CareTemplateItem[]
  routine_items: CareTemplateItem[]
  item_count: number
  status: number
  status_text: string
  sort: number
  create_time: string
  update_time: string
}

export interface CareTemplateListResponseData {
  plan_key: string
  plan_text: string
  list: CareTemplate[]
}

export interface CareTemplateListParams {
  plan_key: string
}

export interface CareTemplateListResponse {
  code: number
  msg: string
  data: CareTemplateListResponseData
}

export function getCareTemplateList(
  params: CareTemplateListParams,
): Promise<CareTemplateListResponse> {
  // return request.post('/api/admin/care-template/list', params)
  return request.post('/api/admin/care-template/list', params)
  //Edit by roshan
}

